export default __webpack_public_path__ + "guide--raster-rasters-emspectrum-480-2c5afed36efeb0ae8b79667d870d26eb.webp";